import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import orderBy from 'lodash/orderBy';
import { OPTIONS_LIMIT } from './constants';
import getOptionScore from './getOptionScore';

var filterOptions = function filterOptions(options, state) {
  var minimumAcceptedScore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (state.inputValue === '') {
    return options.slice(0, Math.min(options.length, OPTIONS_LIMIT));
  }

  var filteredOptions = options.map(function (option) {
    return _objectSpread(_objectSpread({}, option), {}, {
      score: getOptionScore(option.title, state.inputValue)
    });
  }).filter(function (_ref) {
    var score = _ref.score;
    return score > minimumAcceptedScore;
  });
  return orderBy(filteredOptions, 'score', 'desc').slice(0, Math.min(options.length, OPTIONS_LIMIT)).map(function (filteredOption) {
    return {
      inputValue: filteredOption.inputValue,
      title: filteredOption.title,
      id: filteredOption.id
    };
  });
};

export default filterOptions;